module.exports = __webpack_public_path__ + "img/default_image.5f69fc81.jpg";